import React, { useCallback, useEffect, useState } from 'react'
import Container from '../Container/Container'
import { get, ImageUrl } from '../ApiServices/ApiServices'
import { useNavigate } from 'react-router-dom'
import Loader from './Component/Loader'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import { downloadExcel } from '../ApiServices/ApiServices';

function Download() {
	const [loading, setLoading] = useState(true)
	const [data, setData] = useState([])
	const navigate = useNavigate()
	const [searchTerm, setSearchTerm] = useState('');
	const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [count, setCount] = useState(0);
	const [totalPages, setTotalPages] = useState(1);
	const [apiLoading, setApiLoading] = useState(false);
	const [selectedStatus, setSelectedStatus] = useState("");

	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [dateRange, setDateRange] = useState({
		startDate: null,
		endDate: null,
	});
	const [displayLabel, setDisplayLabel] = useState('');
	const [exportLoading, setExportLoading] = useState(false); // New state for export loading

	const fetchDownloads = useCallback(async () => {
		setApiLoading(true);
		try {
			let url = `fetch-downloads?page_number=${currentPage}&size=${itemsPerPage}`;

			if (debouncedSearchTerm) {
				url += `&search=${debouncedSearchTerm}`;
			}
			if (selectedStatus) {
				url += `&status_id=${selectedStatus}`;
			}

			if (dateRange.startDate && moment(dateRange.startDate).isValid()) {
				url += `&start_date=${moment(dateRange.startDate).format('YYYY-MM-DD')}`;
			}

			if (dateRange.endDate && moment(dateRange.endDate).isValid()) {
				url += `&end_date=${moment(dateRange.endDate).format('YYYY-MM-DD')}`;
			}

			const response = await get(url);

			if (response?.status) {
				setData(response?.data?.rows || []);
				const totalCount = response?.data?.count || 0;
				setCount(totalCount);
				setTotalPages(Math.ceil(totalCount / itemsPerPage));
			}
		} catch (err) {
			if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
				localStorage.removeItem('token');
				navigate('/login');
			}
		} finally {
			setLoading(false);
			setApiLoading(false);
		}
	}, [currentPage, itemsPerPage, debouncedSearchTerm, dateRange, selectedStatus, navigate]);

	const downloadReport = () => {
		downloadExcel(`${ImageUrl}/admin/api/export-downloads`, 'Download.csv');
		setTimeout(() => {
			fetchDownloads()
		}, 3000);
	}

	useEffect(() => {
		fetchDownloads();
	}, [fetchDownloads]);

	const status = [
		{ id: 1, name: "Pending", colour: "yellow" },
		{ id: 2, name: "Open", colour: "orange" },
		{ id: 3, name: "Completed", colour: "green" },
		{ id: 4, name: "Cancelled", colour: "red" },
		{ id: 5, name: "Ordered", colour: "blue" }

	];

	const handleStatusChange = (e) => {
		setSelectedStatus(e.target.value);
		setCurrentPage(1);
	};

	const debounce = (func, delay) => {
		let timer;
		return function (...args) {
			clearTimeout(timer);
			timer = setTimeout(() => func.apply(this, args), delay);
		};
	};

	const handleSearch = (e) => {
		const value = e.target.value;
		setSearchTerm(value);
		handleSearchDebounced(value);
	};

	const handleSearchDebounced = useCallback(
		debounce((value) => {
			setDebouncedSearchTerm(value);
			setCurrentPage(1); // Reset to first page when searching
		}, 500),
		[]
	);

	const handlePageChange = (page) => {
		if (page >= 1 && page <= totalPages) {
			setCurrentPage(page);
		}
	};

	const handleItemsPerPageChange = (e) => {
		const newItemsPerPage = Number(e.target.value);
		setItemsPerPage(newItemsPerPage);
		setCurrentPage(1); // Reset to first page when changing items per page
	};

	const handleApply = (event, picker) => {
		setDateRange({
			startDate: picker.startDate,
			endDate: picker.endDate
		});
		setDisplayLabel(`${picker.startDate.format('MMM D, YYYY')} - ${picker.endDate.format('MMM D, YYYY')}`);
		setCurrentPage(1); // Reset to first page when changing date range
	};

	const handleCancel = () => {
		setDateRange({
			startDate: null,
			endDate: null
		});
		setDisplayLabel('');
		setCurrentPage(1); // Reset to first page when clearing date range
	};

	const renderPaginationButtons = () => {
		const buttons = [];
		const maxVisibleButtons = 5;
		let startPage, endPage;

		if (totalPages <= maxVisibleButtons) {
			startPage = 1;
			endPage = totalPages;
		} else {
			const maxButtonsBeforeCurrent = Math.floor(maxVisibleButtons / 2);
			const maxButtonsAfterCurrent = Math.ceil(maxVisibleButtons / 2) - 1;

			if (currentPage <= maxButtonsBeforeCurrent) {
				startPage = 1;
				endPage = maxVisibleButtons;
			} else if (currentPage + maxButtonsAfterCurrent >= totalPages) {
				startPage = totalPages - maxVisibleButtons + 1;
				endPage = totalPages;
			} else {
				startPage = currentPage - maxButtonsBeforeCurrent;
				endPage = currentPage + maxButtonsAfterCurrent;
			}
		}

		for (let i = startPage; i <= endPage; i++) {
			buttons.push(
				<button
					key={i}
					className={`btn btn-sm ${currentPage === i ? 'btn-primary' : 'btn-outline-primary'}`}
					onClick={() => handlePageChange(i)}
					disabled={apiLoading}
				>
					{i}
				</button>
			);
		}
		return buttons;
	};


	const getItemByCategory = (order, categoryName) => {
		if (order.event_type === "Single Order") {
			return order.single_order?.single_order_style?.find(
				(item) => item?.inventory_category?.name === categoryName
			);
		} else if (order.event_type === "Wedding Events") {
			return order.wedding_members?.wedding_style?.find(
				(item) => item?.inventory_category?.name === categoryName
			);
		}
		return null;
	};
	const convertHeight = (height) => {
		if (!height) return '';

		const match = height.match(/^(\d+)'(\d+)"/);
		if (match) {
			const feet = match[1];
			const inches = match[2].padStart(2, '0'); // Ensure 2 digits for inches
			return `${feet}${inches}`;
		}
		return '';
	};


	const shoeSizeMapping = {
		// Standard sizes
		'8K': '080K',
		'9K': '090K',
		'10K': '100K',
		'11K': '110K',
		'12K': '120K',
		'13K': '130K',
		'1K': '001K',
		'2K': '002K',
		'3K': '003K',
		'4K': '004K',
		'5K': '005K',
		'6K': '006K',
		'6.5D': '065D',
		'7D': '070D',
		'7.5D': '075D',
		'8D': '080D',
		'8W': '080W',
		'8.5D': '085D',
		'8.5W': '085W',
		'9D': '090D',
		'9W': '090W',
		'9.5D': '095D',
		'9.5W': '095W',
		'10D': '100D',
		'10W': '100W',
		'10.5D': '105D',
		'10.5W': '105W',
		'11D': '110D',
		'11W': '110W',
		'11.5D': '115D',
		'11.5W': '115W',
		'12D': '120D',
		'12W': '120W',
		'13D': '130D',
		'13W': '130W',
		'14D': '140D',
		'14W': '140W',
		'15D': '150D',
		'15W': '150W',
		'16D': '160D',
		'16W': '160W',
		'17D': '170D',
		'17W': '170W'
	};

	// Function to get mapped size
	const getMappedShoeSize = (size) => {
		if (!size) return '';

		// Convert to string and trim
		const sizeStr = String(size).trim().toUpperCase();

		// Try to find a direct match first
		if (shoeSizeMapping[sizeStr]) {
			return shoeSizeMapping[sizeStr];
		}

		// Try to handle variations (like "6.5 D" vs "6.5D")
		const normalizedSize = sizeStr.replace(/\s+/g, '');
		if (shoeSizeMapping[normalizedSize]) {
			return shoeSizeMapping[normalizedSize];
		}

		// Return original if no match found
		return sizeStr;
	};
	return (
		<Container>
			<div className="nk-content ">
				<div className="container-fluid">
					<div className="nk-content-inner">
						<div className="nk-content-body">
							<div className="nk-block-head nk-block-head-sm">
								<div className="nk-block-between">
									<div className="nk-block-head-content">
										<h3 className="nk-block-title page-title">Welcome to the Download Dashboard</h3>
									</div>
									<div className="nk-block-head-content">
										<div className="toggle-wrap nk-block-tools-toggle">
											{/* <div className="toggle-expand-content" data-content="pageMenu"> */}
											<ul className="nk-block-tools g-3">
												<li className="nk-block-tools-opt">
													<button
														className="btn btn-primary"
														onClick={downloadReport}
													// disabled={exportLoading || apiLoading}
													>
														<span>Export Data</span>
													</button>
												</li>
											</ul>
											{/* </div> */}
										</div>
									</div>
								</div>
							</div>

							<div className="card card-full">
								<div className="card-inner">
									<div className="card-title-group mb-3">
										<div className="row">
											<div className="col-md-12 mb-2">
												<div className="card-tools">
													<div className="form-control-wrap">
														<h5 className="mb-0">Event Items</h5>
														<p>Please choose an option from the menu above.</p>
													</div>
												</div>
											</div>

											<div className='d-flex flex-wrap align-items-center mb-3' style={{ gap: '16px' }}>
												<div className="card-tools" style={{ flex: '1 0 -1px' }}>
													<div className="form-control-wrap customrSearch">
														<label style={{ fontWeight: 'bold' }}></label>
														<div className="form-icon form-icon-right">
															<em className="icon ni ni-search"></em>
														</div>
														<input
															type="text"
															className="form-control"
															placeholder="Search by ticket number or customer name"
															value={searchTerm}
															onChange={handleSearch}
															disabled={apiLoading}
														/>
													</div>
												</div>

												<div className="card-tools" style={{ flex: '1 0 -1px' }}>
													<div className="form-control-wrap">
														<label style={{ fontWeight: 'bold' }}>
															Order Date
														</label>
														<DateRangePicker
															initialSettings={{
																startDate: dateRange.startDate || moment(),
																endDate: dateRange.endDate || moment(),
																locale: {
																	format: 'MMM D, YYYY',
																	cancelLabel: 'Clear',
																	applyLabel: 'Apply',
																},
																ranges: {
																	'Today': [moment(), moment()],
																	'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
																	'Last 7 Days': [moment().subtract(6, 'days'), moment()],
																	'Last 30 Days': [moment().subtract(29, 'days'), moment()],
																	'This Month': [moment().startOf('month'), moment().endOf('month')],
																	'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
																},
																opens: 'right',
																autoApply: true,
																autoUpdateInput: true,
																alwaysShowCalendars: true,
																showCustomRangeLabel: true,
																showCancel: true,
															}}
															onApply={handleApply}
															onCancel={handleCancel}
														>

															<input
																type="text"
																className="form-control"
																placeholder="Select date range"
																value={displayLabel}
																readOnly
																disabled={apiLoading}
																style={{
																	cursor: 'pointer',
																	backgroundColor: '#fff',
																	border: '1px solid #dbdfea',
																	borderRadius: '4px',
																	padding: '0.375rem 0.75rem',
																	minWidth: '142%',
																	paddingRight: '30px',
																	color: '#35495e',
																}}
															/>
														</DateRangePicker>
														{displayLabel && (
															<span
																className="clear-icon"
																onClick={(e) => {
																	e.stopPropagation();
																	e.preventDefault();
																	// Find and trigger the cancel button click
																	const cancelBtn = document.querySelector('.daterangepicker .cancelBtn');
																	if (cancelBtn) {
																		cancelBtn.click();
																	} else {
																		handleCancel();
																	}
																}}
																style={{
																	position: 'absolute',
																	right: '-53px',
																	top: '54%',
																	transform: 'translateY(-50%)',
																	cursor: 'pointer',
																	zIndex: 10
																}}
															>
																<em className="icon ni ni-cross"></em>
															</span>
														)}
													</div>
												</div>
												<div className="card-tools" style={{ flex: '20 0 -1px', marginLeft: "69px" }}>
													<div className="form-control-wrap">
														<label style={{ fontWeight: 'bold' }}></label>
														<select
															className="form-control"
															value={selectedStatus}
															onChange={handleStatusChange}
															style={{
																minWidth: '140%',
																padding: "12px 16px",
																border: '1px solid #dbdfea', // Match search input border
																color: '#35495e', // Match text color
																appearance: 'none', // For consistent styling across browsers
																backgroundImage: "url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%2335495e%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')",
																backgroundRepeat: 'no-repeat',
																backgroundPosition: 'right 0.7rem top 50%',
																backgroundSize: '0.65rem auto',
															}}
														>
															<option value="">Filter by Active Status</option>
															<option value="">All</option>
															{
																status?.map((data) => (
																	<option key={data.id} value={data.id}>
																		{data.name}
																	</option>
																))
															}
														</select>
													</div>
												</div>
											</div>

										</div>
									</div>

									<div className="table-responsive">
										{apiLoading ? (
											<div className="text-center my-5">
												<Loader />
											</div>
										) : (
											<table className="table table-striped">
												<thead>
													<tr>
														<th scope="col">Order Date</th>
														<th scope="col">Occasion</th>
														<th scope="col">Account</th>
														<th scope="col">Slip</th>
														<th scope="col">Event Date</th>
														<th scope="col">Cls</th>
														<th scope="col" className=' tableMinWidth150  '>Full Name</th>
														<th scope="col">Ovam</th>
														<th scope="col">Chest</th>
														<th scope="col">Hgt</th>
														<th scope="col">Wgt</th>
														<th scope="col">Coat</th>
														<th scope="col">Csize</th>
														<th scope="col">Cslve</th>
														<th scope="col">Pant</th>
														<th scope="col">Psize</th>
														<th scope="col">Plen</th>
														<th scope="col">Seat</th>
														<th scope="col">Shirt</th>
														<th scope="col">Ssize</th>
														<th scope="col">Vest</th>
														<th scope="col">Vsize</th>
														<th scope="col">Tie</th>
														<th scope="col">Shoes</th>
														<th scope="col">Ssize</th>
														<th scope="col">Jewel</th>
														<th scope="col">Hanky</th>
														<th scope="col" className=' tableMinWidth150'>Remark</th>
														<th scope="col">Order Status</th>
														<th scope="col">Alt store</th>
													</tr>
												</thead>
												<tbody>
													{data?.length > 0 ? (
														data.map((item, index) => {
															const coatItem = getItemByCategory(item, "Coats");
															const shirtItem = getItemByCategory(item, "Shirt");
															const pantsItem = getItemByCategory(item, "Pants");
															const tieItem = getItemByCategory(item, "Ties");
															const jewelryItem = getItemByCategory(item, "Jewelry");
															const vestItem = getItemByCategory(item, "Vests");
															const shoeItem = getItemByCategory(item, "Shoes");
															const pocketSquareItem = getItemByCategory(item, "PocketSquare");

															// Get the correct source object based on event type
															const orderData = item.event_type === "Single Order" ? item.single_order : item.wedding_members;
															const weddingData = item.event_type === "Wedding Events" ? item.wedding_members?.wedding : null;
															console.log(weddingData?.wedding_date, "weddingData.wedding_date")


															console.log(orderData?.alt_store, "orderDataorderDataorderDataorderData")
															return (
																<tr key={index}>
																	<td className=" tableMinWidth150  ">
																		{orderData?.createdAt
																			? moment(orderData.createdAt).format("MM/DD/YYYY")
																			: weddingData?.createdAt
																				? moment(weddingData.createdAt).format("MM/DD/YYYY")
																				: ''}
																	</td>
																	<th className="tableMinWidth" scope="row">	{orderData?.last_name || item?.user?.lastName || ''}
																	</th>
																	<td className="tableMinWidth">{item?.user?.account || ''}</td>

																	<td className="tableMinWidth">{orderData?.ticket || ''}</td>

																	<td className=" tableMinWidth150  ">
																		{orderData?.event_date
																			? moment(orderData.event_date).format("MM/DD/YYYY")
																			: weddingData?.wedding_date
																				? moment(weddingData.wedding_date).format("MM/DD/YYYY")
																				: ''}
																	</td>
																	<td className="tableMinWidth" >
																		{item?.cls}

																	</td>
																	<td className="tableMinWidth">
																		{orderData?.first_name || item?.user?.firstName || ''} {orderData?.last_name || item?.user?.lastName || ''}
																	</td>
																	<td>{orderData?.overarm || orderData?.member_overarm || ''}</td>
																	<td>{orderData?.chest || orderData?.member_chest || ''}</td>
																	<td>{convertHeight(orderData?.height || orderData?.member_height)}</td>
																	<td>{orderData?.weight || orderData?.member_weight || ''}</td>
																	<td>{coatItem?.style || ''}</td>
																	<td>
																		{coatItem?.size || ''}
																		{coatItem?.size_chart_category?.name === "Short" ? "S" :
																			coatItem?.size_chart_category?.name === "Long" ? "L" :
																				coatItem?.size_chart_category?.name === "Extra Long" ? "X" :
																					coatItem?.size_chart_category?.name === "Regular" ? "R" :
																						coatItem?.size_chart_category?.name === "Boys" ? "B" : ""}
																	</td>
																	<td>
																		{coatItem?.insleeve ? (coatItem.insleeve * 10) : ''}
																	</td>
																	<td>{pantsItem?.style || ''}</td>
																	<td>{pantsItem?.size || ''}</td>
																	<td>
																		{pantsItem?.outseam ? (pantsItem.outseam * 10) : ''}
																	</td>
																	<td>{pantsItem?.hip || ''}</td>
																	<td>{shirtItem?.style || ''}</td>
																	<td>{shirtItem?.shirt_size || shirtItem?.shirt_size || ''}</td>
																	<td>{vestItem?.style || ''}</td>
																	<td>{vestItem?.size || vestItem?.size_chart_category?.size_charts?.[0]?.vestSize || ''}</td>
																	<td>{tieItem?.style || ''}</td>
																	<td>{shoeItem?.style || ''}</td>
																	<td>
																		{getMappedShoeSize(
																			shoeItem?.size ||
																			shoeItem?.size_chart_category?.size_charts?.[0]?.minShoe
																		)}
																	</td>
																	<td>{jewelryItem?.style || ''}</td>
																	<td>{pocketSquareItem?.style}</td>
																	<td>{orderData?.comments || orderData?.notes || ''}</td>
																	<td>{orderData?.status?.name || ''}</td>
																	<td>{item?.alt_store || ''}</td>

																</tr>
															);
														})
													) : (
														<tr>
															<td colSpan="27" className="text-center">
																No data available
															</td>
														</tr>
													)}
												</tbody>
											</table>
										)}
									</div>
									{count > 0 && (
										<div className="nk-block-between-md g-3 mt-3">
											<div className="g">
												<div className="pagination d-flex gap-2 align-items-center">
													<button
														className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
														onClick={() => handlePageChange(currentPage - 1)}
														disabled={currentPage === 1 || apiLoading}
													>
														{apiLoading && currentPage > 1 ? (
															<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
														) : 'Previous'}
													</button>
													{renderPaginationButtons()}
													<button
														className={`btn btn-sm ${currentPage === totalPages ? 'btn-disabled' : 'btn-primary'}`}
														onClick={() => handlePageChange(currentPage + 1)}
														disabled={currentPage === totalPages || apiLoading}
													>
														{apiLoading && currentPage < totalPages ? (
															<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
														) : 'Next'}
													</button>
												</div>
											</div>

											<div className="g">
												<div className="pagination-goto d-flex align-items-center gap-3">
													<div>Showing</div>
													<div>
														<select
															className="form-select form-select-sm"
															value={itemsPerPage}
															onChange={handleItemsPerPageChange}
															disabled={apiLoading}
														>
															{[10, 20, 50, 100].map(size => (
																<option key={size} value={size}>{size}</option>
															))}
														</select>
													</div>
													<div>of {count} items</div>
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Container >
	)
}

export default Download